export default "/images/thanks-confirmation-step.en.jpg?9178c0f701be67e64a9606068a75774e";